import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaCompass } from "react-icons/fa";

export default function NotFound() {
  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center p-4"
      style={{
        background:
          "radial-gradient(ellipse at 30% 20%, rgba(13,148,136,0.12), transparent 50%), #e8eef4",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="text-center"
        style={{ maxWidth: 420 }}
      >
        <div
          className="d-inline-flex align-items-center justify-content-center mb-3"
          style={{
            width: 64,
            height: 64,
            borderRadius: 18,
            background: "var(--tb-accent-soft)",
            color: "var(--tb-accent)",
            fontSize: "1.5rem",
          }}
        >
          <FaCompass />
        </div>
        <h1 className="tb-display fw-bold display-5 mb-2">404</h1>
        <p className="text-muted mb-4">This page is not in the admin map.</p>
        <Link to="/" className="btn btn-primary px-4">
          Back to dashboard
        </Link>
      </motion.div>
    </div>
  );
}
